'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'

import { scrollWindowToTopSmooth } from '@/shared/utils/scrollWindowToTopSmooth'

export function ScrollToTopOnRouteChange() {
  const pathname = usePathname()

  useEffect(() => {
    scrollWindowToTopSmooth()
  }, [pathname])

  return null
}
